export const en = {
    'create-on-preset': 'Build from a template',
    creatives: 'My creatives',
    ideas: 'Creatives ideas',
    presets: 'Standard templates',
    title: 'Ad Builder'
};
